<template>
  <div class="stock-customers-page">
    <section class="hero-banner">
      <div class="banner-content">
        <div class="text-content">
          <h1 class="brand-name">红土证券</h1>
          <h2 class="main-title">委托客户</h2>
          <a :href="resolveLink(externalLinks.openAccount)" target="_blank" rel="noopener noreferrer" class="cta-button">立即开户</a>
        </div>
      </div>
    </section>

    <section class="longbridge-advantages py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="text-center mb-12">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900">委托客户优势</h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz1.png" alt="低费率">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">专业可靠的委托团队，让您智享交易</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz2.png" alt="专业工具">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">专业级交易界面，数据实时同步</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz3.png" class="w-13 h-13" alt="广泛市场">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">全方位委托类型，灵活适配策略</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz4.png" alt="便捷出入金">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">提供清晰直观的交易视图，深度整合实时行情、资金流向与财务数据</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz5.png" alt="个性化服务">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">支持多种订单类型，满足多样化投资需求严格风控体系，保障交易安全</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz5.png" alt="安全保障">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">多层订单验证机制，确保每一笔委托都符合合规要求与风险偏好</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="exclusive-privileges py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div class="privilege-cards">
            <img src="@/assets/bbed8feb7ca7021ecf5d9ff9d3b5ffa0.jpg" alt="股票客户特权">
          </div>
          <div class="text-content">
            <h3 class="text-3xl font-bold text-gray-900 mb-6">进行账户委托的核心条件</h3>
            <ul class="space-y-4 mb-6">
              <li class="flex items-start">
                <span class="w-2 h-2 bg-[#ef7c5b] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span class="text-gray-700 leading-relaxed">符合资格的个人或机构</span>
              </li>
              <li class="flex items-start">
                <span class="w-2 h-2 bg-[#ef7c5b] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span class="text-gray-700 leading-relaxed">具有相应的财务水平</span>
              </li>
              <li class="flex items-start">
                <span class="w-2 h-2 bg-[#ef7c5b] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span class="text-gray-700 leading-relaxed">能够进行风险识别与确认</span>
              </li>
              <li class="flex items-start">
                <span class="w-2 h-2 bg-[#ef7c5b] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span class="text-gray-700 leading-relaxed">通过专业风险测评</span>
              </li>
            </ul>
            <div class="highlight-box p-4 pl-0 mb-6">
              <p class="text-[#ef7c5b] font-semibold text-lg">账户委托，安全先行</p>
            </div>
            <a :href="resolveLink(externalLinks.privilegeLearnMore)" target="_blank" rel="noopener noreferrer" class="bg-[#ef7c5b] cursor-pointer inline-block text-white px-8 py-2 rounded-3xl font-semibold transition-colors">了解详情</a>
          </div>
        </div>
      </div>
    </section>

    <section class="investor-tools py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div class="text-content">
            <h3 class="text-3xl font-bold text-gray-900 mb-6">专业账户委托</h3>
            <ul class="space-y-6">
              <li class="flex items-start">
                <span class="w-3 h-3 bg-orange-500 rounded-full mt-2 mr-4 flex-shrink-0"></span>
                <div>
                  <p class="text-gray-900 font-semibold mb-1">委托我们，成就未来</p>
                  <p class="text-gray-700 leading-relaxed">专业团队运作，让资产在时间中沉淀价值，让未来更具底气</p>
                </div>
              </li>
              <li class="flex items-start">
                <span class="w-3 h-3 bg-orange-500 rounded-full mt-2 mr-4 flex-shrink-0"></span>
                <div>
                  <p class="text-gray-900 font-semibold mb-1">定制专属方案</p>
                  <p class="text-gray-700 leading-relaxed">深入理解您的财务需求，量身打造账户管理计划</p>
                </div>
              </li>
              <li class="flex items-start">
                <span class="w-3 h-3 bg-orange-500 rounded-full mt-2 mr-4 flex-shrink-0"></span>
                <div>
                  <p class="text-gray-900 font-semibold mb-1">您的账户，我们全程守护</p>
                  <p class="text-gray-700 leading-relaxed">资产配置到风险把控，从趋势洞察到时机把握，让资金稳健增长</p>
                </div>
              </li>
            </ul>
            <a :href="resolveLink(externalLinks.investorTools)" target="_blank" rel="noopener noreferrer" class="bg-[#ef7c5b] cursor-pointer inline-block text-white px-8 py-2 mt-4 rounded-3xl font-semibold transition-colors">了解详情</a>
          </div>
          <div class="phone-showcase flex justify-center">
            <img src="@/assets/b2d674eecf05b3f9d9b924b2cb2c0192.jpg" alt="工具展示">
          </div>
        </div>
      </div>
    </section>

    <section class="tech-advantages py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="mb-6">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900">专业托付，财富安心</h2>
          <p class="text-base text-gray-800 mt-2">我们提供全方位账户委托管理服务，以专业策略和严格风控，助您实现资产稳健增值。选择我们，就是选择省心、放心与信心。</p>
        </div>
        <div class="flex gap-6 mb-6 items-center text-gray-600">
          <button v-for="tab in techTabs" :key="tab.key" class="nav-tab" :class="{ active: currentTechTab===tab.key }" @click="currentTechTab=tab.key">{{ tab.label }}</button>
        </div>
        <div class="border-b border-gray-200 mb-8"></div>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
          <div class="tech-card">
            <div class="tech-card-body">
              <div class="tech-title">{{ currentTech.cardLeft.title }}</div>
              <div class="tech-subtitle">{{ currentTech.cardLeft.subtitle }}</div>
            </div>
          </div>
          <div class="tech-card">
            <div class="tech-card-body">
              <div class="tech-title">{{ currentTech.cardRight.title }}</div>
              <div class="tech-subtitle">{{ currentTech.cardRight.subtitle }}</div>
            </div>
          </div>
        </div>
        <p class="text-gray-800 mb-4">{{ currentTech.intro }}</p>
        <ul class="space-y-6 mb-8">
          <li v-for="(adv, idx) in currentTech.advantages" :key="idx" class="flex items-start">
            <span class="advantage-icon-box">
              <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#ef7c5b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle v-if="idx===0" cx="12" cy="12" r="3"/>
                <path v-if="idx===0" d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 11-4 0v-.09A1.65 1.65 0 009.4 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 01-1.51-1H3a2 2 0 110-4h.09A1.65 1.65 0 004.6 9.4a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 114 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1z"/>
                <path v-if="idx===1" d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                <template v-if="idx===2">
                  <rect x="3" y="3" width="18" height="14" rx="2" ry="2"/>
                  <path d="M7 19h10M9 7l2 2 4-4"/>
                </template>
              </svg>
            </span>
            <span class="text-gray-800">{{ adv }}</span>
          </li>
        </ul>
        <div class="text-center">
          <a :href="resolveLink(externalLinks.techLearnMore)" target="_blank" rel="noopener noreferrer" class="learn-more-btn inline-block">了解更多</a>
        </div>
        <div class="mt-8 text-center text-gray-500">值得信赖的证券经纪服务商</div>
      </div>
    </section>

    <section class="trading-capabilities py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="text-center mb-12">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900">强大的交易能力</h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb1.png" class="w-13 h-13" alt="全终端覆盖">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">以客户需求为原则</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 严格遵循客户资产偏好</li>
                  <li>• 严格处理资产配置风险</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb2.png" class="w-13 h-13" alt="多市场覆盖">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">精湛的微观洞察能力</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 细致入微洞察企业</li>
                  <li>• 专业调研确保信息</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb3.png" class="w-13 h-13" alt="实时监控">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">实时监控</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 市场动态与事件提醒</li>
                  <li>• 把握交易机会</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb4.png" class="w-13 h-13" alt="专业研究支持">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">专业的宏观配置能力</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 以大局观做投资</li>
                  <li>• 以宏观视角处理资产</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb5.png" class="w-13 h-13" alt="风控保障">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">丰富的市场经验</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 市场操作精细化</li>
                  <li>• 经验保障财富</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb5.png" class="w-13 h-13" alt="合规保障">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">合规保障</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 严格合规流程</li>
                  <li>• 审计追踪与隐私保护</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="account-types py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8 text-center">
        <h2 class="text-3xl lg:text-4xl font-bold text-gray-900 mb-3">支持账户类型</h2>
        <p class="text-base text-gray-800 mb-8">个人与机构均可开立股票账户</p>
        <div class="flex items-center justify-center gap-12 mb-6">
          <div class="flex flex-col items-center">
            <img src="/assets/khd2.png" alt="个人账户">
            <div class="text-gray-900">个人账户</div>
          </div>
          <div class="flex flex-col items-center">
            <img src="/assets/khd2.png" alt="机构账户">
            <div class="text-gray-900">机构账户</div>
          </div>
        </div>
        <div class="max-w-3xl mx-auto border border-gray-200 rounded-lg p-6 bg-white text-left">
          <h4 class="font-semibold text-gray-900 mb-2">开立机构账户</h4>
          <p class="text-gray-700 text-sm leading-relaxed">机构账户提供更丰富的交易工具与更灵活的服务。如需开立机构账户，请联系客户经理。</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'DelegateCustomers',
  metaInfo: {
    title: '委托客户 - 红土证券'
  },
  data() {
    return {
      defaultTradingUrl: 'https://redland.trade.wbrks.com/Webtrading',
      // 外部链接配置 - 留空时默认跳转交易页
      externalLinks: {
        openAccount: 'https://redland.trade.wbrks.com/Webtrading', // 立即开户按钮
        privilegeLearnMore: 'https://redland.trade.wbrks.com/Webtrading', // 股票客户专享特权 - 了解详情
        investorTools: 'https://redland.trade.wbrks.com/Webtrading', // 专业投资者工具 - 了解详情
        techLearnMore: 'https://redland.trade.wbrks.com/Webtrading' // 领先一代的技术 - 了解更多
      },
      currentTechTab: 'cloud',
      techTabs: [
        { key: 'cloud', label: '优化时间管理' },
        { key: 'order', label: '打破专业壁垒' },
        { key: 'market', label: '稳健财富增值' },
        { key: 'funds', label: '安心风险保障' }
      ],
      techContent: {
        cloud: {
          cardLeft: { title: '高效配置，乐享人生', subtitle: '解放时间实现财富增值' },
          cardRight: { title: '一站式账户委托服务', subtitle: '享受投资成果，而非过程' },
          intro: '成熟的投研团队与风控体系，为您筑起专业壁垒',
          advantages: [
            '承接您在投资管理中的时间消耗，助您实现个人效率与资产效能的同步优化',
            '您专注于创造价值，我们专注于管理风险与捕捉机遇',
            '以我们的专业化劳作，置换您的高价值时间'
          ]
        },
        order: {
          cardLeft: { title: '做您的专业桥梁', subtitle: '穿透市场迷雾、直达投资本质' },
          cardRight: { title: '拆解专业壁垒', subtitle: '为您开创财富之路' },
          intro: '将复合专业能力，系统性地赋予您的资产组合',
          advantages: [
            '专属的投研支持、宏观数据洞察以及稀缺的资产获取渠道',
            '加强配置深度与纪律性，严谨委托流程',
            '与您构建超越市场周期的深层信任关系'
          ]
        },
        market: {
          cardLeft: { title: '实现真正财富稳健增长', subtitle: '平衡风险与收益' },
          cardRight: { title: '跨周期配置财产', subtitle: '穿越牛熊对抗波动' },
          intro: '致力于在不确定性中为您构筑确定性的财富增长',
          advantages: [
            '捕捉经济周期与企业成长的核心红利',
            '专业管理，可持续、可预期抵御增长基础不被侵蚀',
            '完善资产配置和理性持有，让时间成为您财富最可靠的盟友'
          ]
        },
        funds: {
          cardLeft: { title: '以您的风险偏好为绝对前提', subtitle: '做您的想法延伸者' },
          cardRight: { title: '技术抵御多维度风险', subtitle: '为您提供坚实保障' },
          intro: '风险保障客户托付的最终基石，我们将以最严谨、结构化、充满责任感的方式阐述这一核心价值',
          advantages: [
            '资深风控团队，时刻检视风险可能',
            '风险机制建立，让您知晓财产的风险坐标',
            '严谨为先的职业态度，诠释安心价值'
          ]
        }
      }
    }
  },
  methods: {
    resolveLink(url) {
      if (typeof url === 'string' && url.trim()) {
        return url.trim();
      }
      return this.defaultTradingUrl;
    }
  },
  computed: {
    currentTech() {
      return this.techContent[this.currentTechTab] || this.techContent.cloud
    }
  }
}
</script>

<style scoped>
.hero-banner { position: relative; height: 40vh; min-height: 600px; overflow: hidden;  background:url("@/assets/487585e4e8bd59c74850991ff73e9fe8.jpg"); background-size: cover; background-position: center; background-repeat: no-repeat; }
.banner-content { position: absolute; top: 50%; left: 15%; transform: translateY(-50%); z-index: 10; }
.text-content { text-align: left; }
.brand-name { font-size: 1.5rem; font-weight: 300; color: white; margin-bottom: 0.5rem; letter-spacing: 0.1em; }
.main-title { font-size: 3.5rem; font-weight: 700; color: white; margin-bottom: 2rem; letter-spacing: 0.05em; line-height: 1.1; }
.cta-button { background: transparent; color: white; border: 2px solid white; padding: 0.75rem 2rem; font-size: 1rem; font-weight: 500; border-radius: 4px; cursor: pointer; transition: all 0.3s ease; letter-spacing: 0.05em; }
.cta-button:hover { background: white; color: #1e3a8a; transform: translateY(-2px); box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2); }
@media (max-width: 1024px) { .hero-banner { height: 80vh; min-height: 500px; } .main-title { font-size: 2.5rem; } .banner-content { left: 10%; } }
@media (max-width: 768px) { .hero-banner { height: 70vh; min-height: 400px; } .main-title { font-size: 2rem; } .brand-name { font-size: 1.2rem; } .banner-content { left: 8%; } .cta-button { padding: 0.6rem 1.5rem; font-size: 0.9rem; } }
@media (max-width: 640px) { .hero-banner { height: 60vh; min-height: 350px; } .main-title { font-size: 1.8rem; } .brand-name { font-size: 1rem; } .banner-content { left: 5%; } }
.nav-tab { padding: 0.75rem 1rem; font-weight: 500; color: #6b7280; border-bottom: 2px solid transparent; transition: all 0.2s; position: relative; cursor: pointer; background: none; border: none; }
.nav-tab.active { color: #1f2937; border-bottom-color: #1f2937; }
.nav-tab:hover { color: #374151; }
.tech-card { background: #ffffff; border: 1px solid #e5e7eb; border-radius: 0.75rem; }
.tech-card-body { padding: 1.5rem; text-align: center; }
.tech-title { font-size: 1.75rem; font-weight: 700; color: #ef7c5b; }
.tech-subtitle { margin-top: 0.25rem; color: #9ca3af; }
.advantage-icon-box { width: 48px; height: 48px; min-width: 48px; display: inline-flex; align-items: center; justify-content: center; border: 2px dashed #ef7c5b; border-radius: 12px; margin-right: 12px; background: #fff7f4; }
.learn-more-btn { background: #ef7c5b; color: #ffffff; padding: 0.6rem 1.5rem; border: none; border-radius: 1.5rem; font-weight: 600; }
</style>
